export default "__VITE_ASSET__BhS6pn3P__"